import { requestV2 } from "@/config/serve.js";

export async function placementRequest(action, data = {}) {
  const response = await requestV2(
    "post",
    `/adPlacement/${action}`,
    data,
    false,
  );
  // The shared transport returns false on network errors.
  if (!response || response.code !== 0) {
    throw new Error((response && response.msg) || "请求失败");
  }
  return response.data;
}
